<template>
  <div class="filter-slider">
    <div class="filter-slider__number">
      {{ `${minNumber} ${unit}` }}
    </div>
    <div class="filter-slider__slider">
      <n-slider
        v-model:value="numberRange"
        range
        :step="1"
        :min="Object.values(filter['min'])[0] as number"
        :max="Object.values(filter['max'])[0] as number"
        @update:value="
          (val) => {
            minNumber = val[0]
            maxNumber = val[1]
            updateMinMax()
          }
        "
      />
    </div>
    <div class="filter-slider__number filter-slider__number--max">
      {{ `${maxNumber} ${unit}` }}
    </div>
  </div>
</template>

<script setup lang="ts">
import { computed, ref } from 'vue'
import { NSlider } from 'naive-ui'
import { useDebounceFn } from '@vueuse/core'
import { CommonSliderFilterType } from '@/types/filter'

const props = defineProps<{
  unit: string
  summaryPrefix: string
  filter: CommonSliderFilterType
}>()

const minNumber = ref(Object.values(props.filter['min'])[0] as number)
const maxNumber = ref(Object.values(props.filter['max'])[0] as number)

const numberRange = ref([minNumber.value, maxNumber.value])

const updateMinMax = () => {
  changeWidthFilter(Object.keys(props.filter['value'])[0], false)
  changeWidthFilter(Object.keys(props.filter['min'])[0], minNumber.value)
  changeWidthFilter(Object.keys(props.filter['max'])[0], maxNumber.value)

  emits('summary', summary.value)
  debouncedEmit(filtersToEmit.value)
}

const summary = computed(
  () =>
    `${props.summaryPrefix}: ${minNumber.value} - ${maxNumber.value} ${props.unit}`,
)

const filtersToEmit = ref<Record<string, string | number | boolean>>({})
const changeWidthFilter = (key: string, e: number | boolean) => {
  filtersToEmit.value[key] = e
}

const emits = defineEmits<{
  (e: 'updated', val: typeof filtersToEmit.value): void
  (e: 'summary', val: string): void
}>()

const debouncedEmit = useDebounceFn((val) => emits('updated', val), 500)
</script>

<style lang="scss">
.filter-slider {
  display: flex;
  align-items: center;
  gap: 0.8rem;

  &__number {
    flex: 0 0 8rem;

    &--max {
      text-align: right;
    }
  }

  &__slider {
    flex: 1;
  }
}
</style>
